import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOT_COASTAL_SEGMENTS_GROUPS",
    parentId: "PILOT_COASTAL_SEGMENTS_VIEWS",
    applicationRights: Rights,
    title: 'Redigering',
    text: 'Rediger sertifikatomr&aring;der',
    icon: 'map-segments',
    minWidth: 768,
    sequenceNo: 1000,
    url: "/pcs/GROUPS"
})
